const API_PREFIX = "/zqyl-web";
const API_BILL = "/zqyl-stbill-api";
const API_DRAFT = '/zqyl-draft-api'
const API_USER="/userCenter";
const API_POL = "/zqyl-politics-api"
const API_PERFIX_EXTERNAL="/zqyl-external-api";
const API_BP = "/zqyl-bp-api"
const API_MESSAGE = "/messageCenter";//消息服务
const crclFinanceUrl = '/zqyl-crcl-finance-api'

const contractAPI = '/zqyl-contract-api'
export default {
    //45.浙商优惠卷H5获取接口
    'getCouponUrl': crclFinanceUrl + '/zs1002/coupon/getCouponUrl',
    // 获取区块详情
    "getContractSigned": API_PREFIX + "/contractInvoke/allContractCount.htm",
    "saveCloudCard": API_PREFIX + "/CloudCard/saveCloudCard.htm",
    "sendSaveCloudCode": API_PREFIX + "/CloudCard/sendSaveCloudCode.htm",

    // 验证码
    "sendUploadCode": API_PREFIX + "/pzx/sendUploadCode.htm",//发送手机验证码

    //登录前页面
    // 票转信
    "submitTicketToLetter": API_PREFIX+ "/pzx/submitTicketToLetter.htm", //提交表单
    "uploadTicketToLetterFile": API_PREFIX+ "/pzx/uploadTicketToLetterFile.htm", //上传附件
    "getImgRandom": API_PREFIX+ "/app/getImgRandom.htm", //获取图形验证码
    "isUserLogin": API_PREFIX+ "/portal/isUserLogin.htm", //获取用户登录信息
    //融资租赁
    "saveFinanceLease": API_PREFIX+ "/FinanceLease/saveFinanceLease.htm", //提交
    "sendSaveFinanceLease": API_PREFIX+ "/FinanceLease/sendSaveFinanceLease.htm", //手机验证
    // 云投
    "saveCloudCast": API_PREFIX+ "/CloudCast/saveCloudCast.htm",//表单提交 
    "sendSaveCloudCast": API_PREFIX+ "/CloudCast/sendSaveCloudCast.htm",//手机验证码

    //行为验证码验证接口
    "verifyCaptcha": API_USER + "/login/verifyCaptcha",
    //退出登录
    "logout": API_USER +  "/login/logout",
    //个人用户登录
    "login": API_PREFIX + "/user/casLogin.htm",     //密码登录
    "userLogin":API_USER+"/login/login",  //密码登录
    "smsLogin":API_USER +"/login/smsLogin",        //短信登录
    "sendLoginCode": API_USER + "/register/sendUserCode",    //短信登录发送验证码(无图片验证码)
    //退出移除zqyl-web:session
    "removeIndexSession":"/ssl/removeIndexSession.htm",
    //存储session
    "saveIndexSession":"/saveIndexSession.htm",


    //签署协议提交
    "agreeConfirm":API_DRAFT+"/agree/confirm",
    //蓝海银行增加 start by_pyh 点击票据时校验是否签署票据服务协议
    "isAgree":API_DRAFT+"/agree/check",

    "switchCompany": API_USER + "/company/switchCompany",//切换企业
    "setDefaultCompany": API_USER + "/company/setDefaultCompany",//设置默认企业
    "getLoginRandom": API_USER + "/register/getServerRandomCode", //获取服务端随机数
    "queryUserIdBindCompanyList": API_USER + "/userManager/queryUserUsableCompanyList",//获取企业列表
    "getCompanyUser":API_USER+"/userManager/getCacheCustInfo",	//获取当前企业及用户信息
    "queryAllFunctionList": API_USER + '/login/queryUserSourceList',	// 获取权限菜单
    "getADList": API_PREFIX + "/redis/getListById.htm",					//获取广告
    "getInsCert":API_PREFIX + "/join/getCompanyJoin.htm",			//合作运营机构认证
    
    //政E信宣传页
    "findAllPartner":API_POL + "/web/partner/findAllPartner",
    "saveIntentionCompany":API_POL + "/web/intention/saveIntentionCompany",
    //前台-拟融资申请验证手机号是否存在
    "getIntentionMobile":API_POL + "/app/intention/getIntentionMobile",
    
    "getNews":API_PREFIX + "/portal/getAllContContentList.htm",

    // 企业函证的邮箱
    // 根据验证码和电子邮件地址查询资源文件
    "queryCrclConfirmByVerfiCode": API_PERFIX_EXTERNAL + "/crclConfirm/queryCrclConfirmByVerfiCode",
    
    
    //ZEX意向客户
    'sendMobileVerifyCode':API_USER+'/register/sendMobileVerifyCode',
    
    // 云投
    "financingProjectList":API_BP + "/enterpriseService/financingProjectList",  //查询所有已发布融资企业项目
    "sendCaptcha":API_BP + "/enterpriseService/sendCaptcha",                                 //发送验证码
    "financialAdvisoryAgreementSave":API_BP + "/enterpriseService/financialAdvisoryAgreementSave",  //保存申请
    "dataDictionaryList":API_BP + "/enterpriseService/dataDictionaryList", //获取融资轮次枚举

    //token登录 使用token登录，若token为空，或校验失败，则status为M0200，data.isTokenSucc返回为false，异常情况也是返回M0200，不报错；如果token校验通过，则返回与登录相同结构的数据
    //解决打开两次登录页面，造成登录两次 问题 新增的接口
    'tokenLogin': API_USER + '/login/tokenLogin',
    
    // 获取二维码信息
	"queryQrcode": API_USER + "/auth/custFriends/queryQrcode",
	//发送手机验证码（无图片验证码）
	"sendUserCode": API_USER + "/register/sendUserCode",
    //软认证企业信息变更短信校验
    "verifyMobilCodeByLoginFront": API_USER + "/register/verifyMobilCodeByLoginFront",
    // 企业好友保存
    "saveCustFriendsByLoginFront":API_USER + "/auth/custFriends/saveCustFriendsByLoginFront",
    "getCompanyNum": API_PREFIX + "/portal/getRegisterCompanyCount.htm",	//首页banner数据

    "allContractCount": contractAPI + "/contractInvoke/allContractCount",	//首页banner数据

	// 查询链信消息正文
	"findLianXinIMUrlContent": API_MESSAGE + "/message/findLianXinIMUrlContent",
};